import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = ({ onSignUp }) => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-coral-500 via-orange-500 to-amber-500 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Icon */}
        <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
          <Icon name="Heart" size={40} className="text-white" />
        </div>

        {/* Headline */}
        <h2 className="text-3xl md:text-5xl font-bold text-black mb-6 leading-tight">
          Ready to Make a Difference?
        </h2>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-black mb-8 leading-relaxed max-w-2xl mx-auto">
          Join thousands of changemakers who are transforming lives through strategic, impactful giving.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <Button
            size="lg"
            onClick={onSignUp}
            className="bg-white text-coral-600 hover:bg-gray-50 px-8 py-4 text-lg shadow-2xl hover:shadow-3xl transition-all transform hover:scale-105"
            iconName="ArrowRight"
            iconPosition="right"
          >
            Start Your Journey Free
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/10 px-8 py-4 text-lg backdrop-blur-sm"
            iconName="Play"
            iconPosition="left"
          >
            Watch Demo
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-black">
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={16} />
            <span>No credit card required</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} />
            <span>100% secure platform</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={16} />
            <span>Join 15,000+ givers</span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 pt-12 border-t border-white/20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-black mb-2">$1.2M+</div>
              <div className="text-black text-sm">Total Donated</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-black mb-2">15K+</div>
              <div className="text-black text-sm">Active Donors</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-black mb-2">340+</div>
              <div className="text-black text-sm">Causes Supported</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-black mb-2">180+</div>
              <div className="text-black text-sm">Nonprofit Partners</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;